import { type Enum } from '@webapp/infrastructure/types/Enum'

// Transport mode of a trip (numeric `Transport` codes from destination payloads).
// API/config names: Drive/Flight/Rail/Sail; trip-modal UI labels: Car/Plane/Train/Marine.
export const TravelTransportTypes = {
  DRIVE: 0,
  FLIGHT: 1, // Default for new trips
  RAIL: 2,
  SAIL: 3,
} as const

export type TravelTransportTypeEnum = Enum<typeof TravelTransportTypes>
